import { render, staticRenderFns } from "./PlanningAuthority.vue?vue&type=template&id=ef58f692&"
import script from "./PlanningAuthority.vue?vue&type=script&lang=ts&"
export * from "./PlanningAuthority.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports